import {IconChevronRight, VisuallyHidden} from '@treatwell/ui';
import clsx from 'clsx';
import React, {lazy} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './DayList.module.css';
const Spinner = lazy(() => import('./spinner.svg'));

export const NavButtonPrevious = ({
  hide,
  onClick,
}: {
  hide?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const {t} = useTranslation();
  return (
    <NavButton
      hide={hide}
      label={t('calendarNavigation.labels.previous')}
      direction="previous"
      dataCy="CalendarNavigationPrevious"
      onClick={onClick}
    />
  );
};

export const NavButtonNext = ({
  hide,
  onClick,
  isLoading,
}: {
  hide?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
}) => {
  const {t} = useTranslation();
  return (
    <NavButton
      hide={hide}
      label={t('calendarNavigation.labels.next')}
      direction="next"
      isLoading={isLoading}
      dataCy="CalendarNavigationNext"
      onClick={onClick}
    />
  );
};

type NavButtonProps = {
  label: string;
  direction: 'previous' | 'next';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hide?: boolean;
  dataCy?: string;
  isLoading?: boolean;
};

const NavButton = ({
  label,
  direction,
  onClick,
  hide,
  isLoading,
  dataCy,
}: NavButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-hidden={hide}
      disabled={hide}
      data-cy={dataCy}
      className={clsx(styles.navButton, {
        [styles.previous]: direction === 'previous',
        [styles.hide]: hide,
      })}
    >
      <React.Suspense fallback={null}>
        {isLoading ? (
          <Spinner data-cy="PaginationSpinner" />
        ) : (
          <IconChevronRight size={24} />
        )}
        <VisuallyHidden as="span">{label}</VisuallyHidden>
      </React.Suspense>
    </button>
  );
};
